import React, { Component } from 'react';

export class Historic extends Component {
  render() {
    return (
    <div>
      <p>This is the HISTORIC Page content.</p>
    </div>
  );
}}
